var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5443_45686",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5443_45686",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACJUlEQVRo3u2aPU/CUBSGGXQyxkUmV8UYExlEWj93YwvRzRgI6i/QnQkTGfwbLkYgjibq5ORnHDVuosbEmDhA4kdS32NKbKBCS7ltD3qTZwGG97kt0HvOCQT+1896Pe7pAlGwCNZAWmdNf43e6/JN4Ad1PPCy3RdGqAw4BR9Aa8CH/tnM4VF/eHgn5X7wR2WqAyTB+XN2QLMQ2pStfUkbzKfOQQJ0CA9+H5uh8HFwAzTiORtyICCTQIVrEB/IJ4Ttei/IVYILEKiQA72tDh8Fd9XhBQkQdyDaqvAqKJuFFyhAlIDSivDvv4UXLEC8NS2BcFK9nXdJgCjbvp0QLAiKjcK7JEAUQdBaeHWaBApWwrsoQBRChZSl3V+wGt5lAWK+UfhOcOtjgVvQWU9g2U54DwSIZdPwT8okCVwxELgK5VdMdz9iN7xHAsSomUCWkcCmmcAlI4GL6vDd4JORwCfoNgrIzYT3UICQjQJLDAWWjALrDAXWjQJphgLpthJgfwux/xKz/xnl/UemS1ywfZTQBTa5P8yNMhKI1NY9VT4HmqFcqg2PlG1xqNcl5n0ssNC4LjT3XdjK+7GwBf5AabGqJ1DySXFXarZCrYA3j8vrqtMegVLvSggUKDsOb5AYY9tiqmry7brU5AsGRKyn2QkSiYFrAQI31GYd3F1xrdGdAGfOGt1ypdGddKXRXXNFYhKNGozoowYnNkcNNg5o1GBv9X/Yg/X6AkX9EzVLuyToAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM8);
export default __webpack_public_path__ + "static/media/m8.405c1b4110a45d702c85040863d4f178.svg";
export { ForwardRef as ReactComponent };